
export class LossTypeModel {
    id: string;
    operationTypeId: number;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/loss-type-model.ts